import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
  ref,
  onMounted,
  nextTick,
  onBeforeUnmount,
  useSlots,
  watch,
  onUpdated
} from 'vue'
import { useStore } from 'vuex'
import memberDialog from './MemberDialog.vue'
import factory from './MemberSlotRender'
import { confirmLoginWithNoCurShop } from '@/util/useConfirm'
import { Site } from '@/common/const'
import { useSite } from '@/store'
interface ICON {
  [key: string]: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
  icon: {
    type: String,
    default: 'member_long'
  },
  maxShowTime: {
    type: Number,
    default: 1
  },
  memberLevel: {
    type: Number,
    default: 1
  },
  fn: Function,
  stopPropagation: {
    type: Boolean,
    default: true
  },
  preventDefault: {
    type: Boolean,
    default: true // 默认阻止原生事件 a标签跳转之类的
  },
  observeListen: Boolean,
  subscript: {
    type: Boolean,
    default: true
  },
  subscriptAppendToBody: Boolean,
  dialog: {
    type: Boolean,
    default: true
  },
  targetComp: {
    type: Element
  },
  style: Object,
  listenVariable: Object || Array,
  noTokenFn: {
    type: Function,
    default: () => { }
  }
},
  setup(__props) {

const props = __props
const store = useStore()
const user = computed(() => store.getters.user)
const token = store.getters.token


const iconList: any = {
  [Site.JA]: {
    member_long:
      'https://static-s.theckb.com/BusinessMarket/icon/member_long.png',
    member_coin: require('@/assets/image/icon/member/tag_vip_only3@2x.png'),
    member_oem: require('@/assets/image/icon/member/tag_business_only@2x.png'),
    member_header:
      'https://static-s.theckb.com/BusinessMarket/icon/member_long.png'
  },
  [Site.KO]: {
    member_long: require('@/assets/image/icon/member/vip_only_kr1.png'),
    member_coin: require('@/assets/image/icon/member/vip_only_kr2.png'),
    member_oem: require('@/assets/image/icon/member/tag_business_only@2x.png'),
    member_header: require('@/assets/image/icon/member/vip_only_kr1.png')
  },
  [Site.EN]: {
    member_long: 'https://static-s.theckb.com/BusinessMarket/member/vip_only_en1.png',
    member_coin: 'https://static-s.theckb.com/BusinessMarket/member/vip_only_en2.png',
    member_oem: 'https://static-s.theckb.com/BusinessMarket/member/tag_business_only_en.png',
    member_header: 'https://static-s.theckb.com/BusinessMarket/member/vip_only_en1.png'
  }
}
const iconUri = iconList[props.icon]
const iconClass = ref(props.icon)

const visible = ref(false)

const slots = useSlots()
const defaultSlot = ref(slots.default && slots.default()[0])
const defaultSlotRef = ref()
const observer = new IntersectionObserver((changes) => {
  for (const change of changes) {
    if (change.intersectionRatio > 0 && onShowTime.value < props.maxShowTime) {
      onShowTime.value += 1
      // visible.value = true
      store.commit('status/memberDialog', true)
      if (!(onShowTime.value < props.maxShowTime)) {
        observer.unobserve(defaultSlotRef.value.$el)
      }
    }
  }
}, {})

const listenTarget = ref()
function onSlotMounted () {
  if (!token || user?.value?.membership?.templateLevel < props.memberLevel) {
    if (props.subscript) {
      const target = props.targetComp
        ? props.targetComp
        : defaultSlotRef.value.$el
      target.className += ` ${props.icon} memberEventBox ${useSite()}`
      // props.style && Object.keys(props.style).forEach(key=>defaultSlotRef.value.$el.style[key] = props.style[key])
    }
    if (props.stopPropagation) {
      defaultSlotRef.value.$el.parentElement.addEventListener(
        'click',
        memberEvent,
        true
      )
      listenTarget.value = defaultSlotRef.value.$el.parentElement
    }
  }
}
function onSlotUnmounted () {
  if (props.subscript && listenTarget.value) {
    listenTarget.value.removeEventListener('click', memberEvent)
  }
}
function memberEvent (event: MouseEvent) {
  if (
    isDOMContains(
      defaultSlotRef.value.$el,
      event.target,
      defaultSlotRef.value.$el.parentElement
    )
  ) {
    event.stopPropagation()
    if (props.preventDefault) {
      event.preventDefault
        ? event.preventDefault()
        : (event.returnValue = false)
    }
    if (!token) {
      confirmLoginWithNoCurShop(() => {
      }, () => {
        props.noTokenFn()
      })
      return
    }
    props.fn ? props.fn() : store.commit('status/memberDialog', true)
  }
}
const RenderComp = factory({
  mountedCallFun: onSlotMounted,
  unmountedCallFun: onSlotUnmounted
})

const onShowTime = ref(0)
if (
  props.observeListen &&
  user?.value?.membership.templateLevel < props.memberLevel
) {
  onMounted(async () => {
    await nextTick()
    if (props.observeListen && defaultSlotRef.value.$el?.nodeType === 1) {
      try {
        observer.observe(defaultSlotRef.value.$el)
      } catch (error) {
        console.log(error)
      }
    }
  })
  onBeforeUnmount(() => {
    if (props.observeListen && observer && defaultSlotRef.value.$el?.nodeType === 1) {
      console.log(defaultSlotRef.value.$el)
      observer.unobserve(defaultSlotRef.value.$el)
    }
  })
}
function isDOMContains (parentEle: Element, ele: Element, container: Element) {
  // parentEle: 要判断节点的父级节点
  // ele:要判断的子节点
  // container : 二者的父级节点
  if (parentEle === ele) {
    return true
  }
  if (!ele || !ele.nodeType || ele.nodeType !== 1) {
    return false
  }
  // 如果浏览器支持contains
  if (parentEle.contains) {
    return parentEle.contains(ele)
  }
  // 火狐支持
  if (parentEle.compareDocumentPosition) {
    return !!(parentEle.compareDocumentPosition(ele) & 16)
  }
  // 获取ele的父节点
  let parEle = ele.parentNode
  while (parEle && parEle !== container) {
    if (parEle === parentEle) {
      return true
    }
    parEle = parEle.parentNode
  }
  return false
}

watch(
  () => props.listenVariable,
  (v) => {
    defaultSlot.value = slots.default && slots.default()[0]
  },
  { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RenderComp), {
    ref: (_value, _refs) => {
      _refs['defaultSlotRef'] = _value
      defaultSlotRef.value = _value
    },
    vnode: defaultSlot.value
  }, null, 8, ["vnode"]))
}
}

})